import { Col, Container, Row } from "react-bootstrap";
import logo from "../../assets/img/manzil-logo.png";

import moment from "moment";
import { BsWhatsapp } from "react-icons/bs";
import { MdCall } from "react-icons/md";
import { FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { useContext, useEffect, useState } from "react";

import { BiLogoInstagramAlt, BiLogoLinkedin } from "react-icons/bi";
import "./Footer.css"
import { IoCallSharp, IoLocationSharp, IoMail } from "react-icons/io5";

export default function Footer() {
  const [atBottom, setAtBottom] = useState(false);

  const handleScroll = () => {
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const scrollY = window.scrollY;

    // Check if we're at the bottom (taking into account edge cases with small offsets)
    const isAtBottom = scrollY + windowHeight >= documentHeight - 1; // a small offset to prevent float point errors

    setAtBottom(isAtBottom);
  };


  return (
    <>
      <Container className="border-top footer" fluid>
        <Row className="py-3">
          <Col lg={3}>
            <div className="mt-4 mb-2">
              <a href="/" className="ps-1 d-inline w-auto">
                <img src={logo} className="img-fluid" alt="Manzil" />
              </a>
              <p>We focus on extending beyond serving people of determination, focusing on empowering all learners and fostering inclusive education.
              </p>
            </div>
            <div className="ls-bottom footer-links order-1 order-lg-2">
              <ul className="mb-2 mb-lg-0 pe-lg-4 mb-0 p-0">

                <li>
                  <a
                    href="https://www.facebook.com/ManzilCentre/?ref=hl"
                    target="_blank" className="facebook-icon">
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/manzil_center/" target="_blank" className="insta-icon">
                    <BiLogoInstagramAlt />
                  </a>
                </li>
                <li>
                  <a href="https://in.linkedin.com/company/manzil" target="_blank" className="linkedin-icon">
                    <BiLogoLinkedin />
                  </a>
                </li>
              </ul>
            </div>
          </Col>
          <Col lg={3} className="mt-4">
            <h5 className="links"><span>Quick Links</span></h5>
            <ul className="mb-2 mb-lg-0 pe-lg-4 mb-0 p-0 quick-links">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/our-story">Our Story</a>
              </li>
              <li>
                <a href="/services">Services</a>
              </li>
              <li>
                <a href="/technology-innovation">Technology & Innovation</a>
              </li>
              <li>
                <a href="/knowledge-center">Knowledge Centre</a>
              </li>



            </ul>
          </Col>
          <Col lg={3} className="mt-4">
            <h5 className="links"><span>Services</span></h5>
            <ul className="mb-2 mb-lg-0 pe-lg-4 mb-0 p-0 quick-links">
              <li>
                <a href="/child-skill-development">Child Skill Development</a>
              </li>
              <li>
                <a href="/occupational-skills">Occupational Training</a>
              </li>
              <li>
                <a href="/work-based-placement">Work Based Placement</a>
              </li>
              <li>
                <a href="/corporate-training">Corporate Training </a>
              </li>

              <li>
                <a href="/consultancy">Consultancy</a>
              </li>


            </ul>
          </Col>
          <Col lg={3} className="mt-4 contact-us">
            <h5 className="links"><span>Contact Us</span></h5>
            <div className="d-flex">
              <div className="contact-us-icon align-self-start">
                <IoLocationSharp />
              </div>
              <div>
                <h5 className="mb-1">
                  Manzil Dubai <br /> (Occupational Skills)
                </h5>
                <a
                  href="https://goo.gl/maps/mPwXm4Z4xjJJWUPx6"
                  target="_blank"
                >
                  Office 505, Nastaran Building, jadaf Waterfront, Dubai
                </a>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <div className="contact-us-icon">
                <IoCallSharp />
              </div>
              <div>
                <a href="tel:+97145294037">+9714 529 4037</a>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <div className="contact-us-icon">
                <IoMail />
              </div>
              <div>
                <a href="mailto:management@manzil.ae">management@manzil.ae</a>
              </div>
            </div>
          </Col>

        </Row>


        <Row className="flex-column-reverse flex-lg-row py-lg-3 pt-3 copyright-section">
          <Col lg={6} className="text-center text-lg-start">
            Design{" "}
            <a href="http://globaltrendz.com/" target="_blank" className="text-white">
              Global Trendz
            </a>
          </Col>
          <Col lg={6} className="mb-2 mb-lg-0 text-center text-lg-end">
            &copy; {moment().format("YYYY")} Manzil Center. All Rights
            Reserved.
          </Col>
        </Row>
      </Container>
    </>
  );
}
